import { render } from "./ProductCardsShop.vue?vue&type=template&id=5456275a&scoped=true"
import script from "./ProductCardsShop.vue?vue&type=script&lang=js"
export * from "./ProductCardsShop.vue?vue&type=script&lang=js"

import "./ProductCardsShop.vue?vue&type=style&index=0&id=5456275a&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5456275a"]])

export default __exports__